import { ThemeUICSSObject } from 'theme-ui';
import { spacing } from '../../util';
import getColorsAndStatesByPath from '../colors/util/getColorsAndStatesByPath';
/* IMPORT HERE */

const select: ThemeUICSSObject = {
  variant: 'text.default',
  display: 'inline-block',
  fontFamily: 'body',
  p: spacing(4),
  pr: 7,
  borderRadius: 'default',
  width: '100%',
  maxWidth: '100%',
  '& ~ svg': {
    background: 'transparent',
  },
  ...getColorsAndStatesByPath('form.fields', {
    states: {
      active: false,
      hover: false,
      focus: false,
    },
  }),

  '&[multiple] ~ svg': {
    display: 'none',
  },
};

export default select;
